import { apiFetch, type AjaxResult } from './http';

export type AppNotice = {
  noticeId: number;
  title: string;
  content: string;
  readFlag: string;
  createTime: string;
};

export async function fetchNoticeList(): Promise<AjaxResult<AppNotice[]>> {
  return apiFetch('/api/app/notice/list', { method: 'GET', auth: true });
}

export async function fetchUnreadCount(): Promise<AjaxResult<{ count: number }>> {
  return apiFetch('/api/app/notice/unreadCount', { method: 'GET', auth: true });
}

export async function markNoticeRead(noticeId: number): Promise<AjaxResult<unknown>> {
  return apiFetch(`/api/app/notice/markRead?noticeId=${encodeURIComponent(String(noticeId))}`, {
    method: 'POST',
    auth: true,
  });
}

export async function markAllNoticeRead(): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/notice/markAllRead', { method: 'POST', auth: true });
}
